// BillingActionsCard.js
import { BILLING_EMAIL } from '../../utils/billingStatus';

const SETTLED = new Set(['active', 'manual']);

export default function BillingActionsCard({ facilityName, status }) {
    const subject = encodeURIComponent(`Billing for ${facilityName || 'our agency'}`);
    const lead = SETTLED.has(status)
        ? 'To add seats or update payment details, email us.'
        : 'To activate your plan, add seats, or update payment details, email us.';
    return (
        <section className="billing-card billing-card--actions">
            <h2 className="billing-card-title">Changes</h2>
            <p className="billing-card-detail">{lead} We reply within one business day.</p>
            <div className="billing-actions">
                <a className="billing-btn billing-btn-primary" href={`mailto:${BILLING_EMAIL}?subject=${subject}`}>Contact billing</a>
                {/* A7 (Stripe Checkout / portal) wires these: POST /billing/checkout and POST /billing/portal. */}
                <button type="button" className="billing-btn billing-btn-ghost" disabled title="Coming soon">Subscribe</button>
                <button type="button" className="billing-btn billing-btn-ghost" disabled title="Coming soon">Manage billing</button>
                <span className="billing-actions-note">Self-serve billing is coming soon.</span>
            </div>
        </section>
    );
}
